export function bookingByInvitePayload(aboutYouDetails, chosenProduct, chosenSlot, accessories, bookingId, invite, operatorId) {
    const selectedAccessories = accessories.map(a => ({
        Accessory: {
            ID: a.id
        }
    }));
    return {
        userId: aboutYouDetails.email,
        customer: {
            "First name": aboutYouDetails.firstName,
            "Last name": aboutYouDetails.lastName,
            "Phone number": aboutYouDetails.phone,
            "Email": aboutYouDetails.email
        },
        booking: {
            _recordId: bookingId,
            Date: chosenProduct.id,
            Time: chosenSlot.id,
            Price: 0,
            Paid: 0,
            "First line of address": aboutYouDetails.firstLineOfAddress,
            "Postcode": aboutYouDetails.postcode,
            "Notes": aboutYouDetails.notes,
            Jobs: [{
                    Service: { ID: chosenProduct.productId },
                    Make: aboutYouDetails.makeOfCar,
                    Model: aboutYouDetails.modelOfCar,
                    "Year and colour": aboutYouDetails.yearAndColourOfCar,
                    "Selected Accessories": selectedAccessories
                }],
            "Back Office": { "Operator ID": operatorId }
        },
        invitation: {
            "Unique Code": invite.uniqueCode
        }
    };
}
